import isFirstMessage from "./isFirstMessage";

export default function (type, currentCampaign) {
  if (currentCampaign?.inbound || currentCampaign?.referrals) {
    return true;
  }

  return isFirstMessage(type);
}
